import { Routes } from '@angular/router';
import { BlogType01Component } from './blog-type01/blog-type01.component';
import { BlogType02Component } from './blog-type02/blog-type02.component';

export default [
    {
        path     : '',
        component: BlogType01Component,
    },
    {
        path     : 'travel-blog',
        component: BlogType02Component,
    },
    
] as Routes;
